import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { CheckCircle, Crown, ArrowRight } from 'lucide-react';
import { clearLimitsCache } from '@/hooks/useLimits';

export default function SubscriptionSuccessPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // Invalidate subscription queries to refresh the status
  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ['subscription'] });
    queryClient.invalidateQueries({ queryKey: ['subscription-details'] });
    // Der Limit-Cache liegt nicht in react-query und wuerde sonst bis zu
    // 5 Minuten das alte Free-Limit weiterreichen.
    clearLimitsCache();
  }, [queryClient]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="text-center max-w-sm">
        {/* Success Icon */}
        <div className="w-20 h-20 mx-auto mb-6 glass-effect rounded-full flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-green-400" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-white mb-2">
          Willkommen bei Premium!
        </h1>

        {/* Description */}
        <p className="text-white/70 mb-8">
          Dein Abo wurde erfolgreich aktiviert. Du hast jetzt Zugriff auf alle Premium-Features.
        </p>

        {/* Premium Badge */}
        <div className="inline-flex items-center gap-2 bg-pp-orange/20 border border-pp-orange/30 text-pp-orange px-4 py-2 rounded-full mb-8">
          <Crown className="w-5 h-5" />
          <span className="font-medium">Premium aktiv</span>
        </div>

        {/* Features unlocked */}
        <div className="glass-effect rounded-[15px] p-4 mb-8 text-left">
          <p className="text-sm font-medium text-white mb-3">
            Jetzt freigeschaltet:
          </p>
          <ul className="space-y-2 text-sm text-white/70">
            <li className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-400" />
              Unbegrenzte KI-Fragen
            </li>
            <li className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-400" />
              Unbegrenzte Namen-Swipes
            </li>
            <li className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-400" />
              Prioritäts-Support
            </li>
            <li className="flex items-center gap-2">
              <CheckCircle className="w-4 h-4 text-green-400" />
              Keine Werbung
            </li>
          </ul>
        </div>

        {/* CTA Button */}
        <button
          onClick={() => navigate('/')}
          className="w-full py-4 bg-pp-orange text-white font-medium rounded-[15px] hover:bg-pp-orange/90 transition-colors flex items-center justify-center gap-2"
        >
          Los geht's
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
